<template lang="pug">
  .affirm-messaging(:class="{'has-message': displayPerMonthMessage || displayCustomMessage}")
    .affirm-per-month(
      v-if="displayPerMonthMessage"
      class="affirm-as-low-as"
      data-page-type="product"
      :data-amount="formattedPrice"
    )
    .affirm-custom-message(v-else-if="displayCustomMessage")
      span(v-html=`__("Pay at your own pace at 0% APR with")`)
      StaticImage.affirm-img(
        src="/UI/logos/affirm_black_logo-white_bg_kwbry0.webp"
        :alt="__('Affirm')"
        :width="405"
        :height="165"
      )
      span(v-html=`__(".")`)
</template>
<script setup lang="ts">
import { computed, onMounted, watch } from 'vue'
import { useRogue } from '@/js/services/Rogue'
import { updateUI } from '@orders'
import type { IProduct } from '@rogue/universal'

const props = defineProps<{
  price: number,
  product: IProduct,
} > ()

const rogue = useRogue()

const formattedPrice = computed<number>(() => props.price * 100)

const displayPerMonthMessage = computed<boolean>(() => {
  const products = [115677, // C2 RowerErg
    54706, // Echo Bike
    50765, // C2 BikeErg
    20151, // C2 SkiErg
    81283, // Trueform Trainer
    64192, // Trueform Runner Config

  ]

  return props.product.attributes?.show_affirm_promo || products.includes(props.product.productId)
})

const displayCustomMessage = computed<boolean>(() => {
  const products: number[] = []

  return products.includes(props.product.productId)
})

watch(() => props.price, () => {
  updateUI(rogue.keys.affirm, rogue.log)
})

onMounted(() => {
  updateUI(rogue.keys.affirm, rogue.log)
})
</script>
<style lang="scss" scoped>
.affirm-messaging {
  margin-top: $size-xs;
  margin-bottom: $size-s;
  font-size: $size-xs;

  &.has-message {
    min-height: 19px;
  }
}

.affirm-custom-message {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.affirm-img {
  max-width: 43px;
  width: 100%;
  top: -4px;
  margin-left: 5px;
}

@include mobile() {
  .affirm-img {
    top: -6px;
  }
}

@include tablet() {
  .affirm-img {
    top: -5px;
  }
}
</style>
